import { ActionWithOptionalPayload } from '../../store/typings';

export type ActionReducerState = {
    type: any;
    count: number;
};

const initialState: ActionReducerState = {
    type: null,
    count: 0,
};

export default (state = initialState, action: ActionWithOptionalPayload) => {
    return {
        ...state,
        type: action.type,
        count: state.count + 1,
    };
};
